import { gql } from 'apollo-boost'

export const USER = gql`
  query userForChat($data: userForChat) {
    userForChat(data: $data)
  }
`
